import React, { useEffect, useState } from "react";
import { FaArrowRotateRight } from "react-icons/fa6";

import { pastasAnaliseAcessos } from "../../services/http/dashboardService";

// Filtros e utilitários compartilhados entre o Dashboard (Análise de Acessos) e os
// relatórios completos (RD 94908).

export const PERFIS = ["Administrador", "Participante", "Mídia", "Link público"];

const doisDigitos = (n) => String(n).padStart(2, "0");
const paraIso = (data) =>
  `${data.getFullYear()}-${doisDigitos(data.getMonth() + 1)}-${doisDigitos(data.getDate())}`;

/** Padrão: 1º dia do mês corrente até hoje. */
export const filtrosPadrao = () => {
  const hoje = new Date();
  return {
    dataInicio: paraIso(new Date(hoje.getFullYear(), hoje.getMonth(), 1)),
    dataFim: paraIso(hoje),
    perfil: "",
    acao: "",
    idPasta: "",
  };
};

export const filtrosDaQuery = (search) => {
  const query = new URLSearchParams(search);
  const padrao = filtrosPadrao();
  return Object.keys(padrao).reduce(
    (filtros, campo) => ({ ...filtros, [campo]: query.get(campo) || padrao[campo] }),
    {}
  );
};

export const filtrosParaQuery = (filtros) =>
  new URLSearchParams(Object.entries(filtros).filter(([, valor]) => valor)).toString();

export const periodoValido = (filtros) =>
  Boolean(filtros.dataInicio && filtros.dataFim && filtros.dataFim >= filtros.dataInicio);

/** "2026-10-01T00:00:00" -> "01/10/2026" */
export const formatarData = (valor) =>
  valor ? valor.substring(0, 10).split("-").reverse().join("/") : "";

export const formatarNumero = (valor) =>
  Number(valor ?? 0).toLocaleString("pt-BR", { maximumFractionDigits: 1 });

export function FiltrosAnalise({ filtros, setFiltros, onAtualizar, carregando, children }) {
  const [pastas, setPastas] = useState([]);

  useEffect(() => {
    pastasAnaliseAcessos().then((resposta) => {
      if (!resposta.fail) setPastas(resposta.data ?? []);
    });
  }, []);

  const alterar = (campo) => (evento) => setFiltros({ ...filtros, [campo]: evento.target.value });

  return (
    <section className="filters">
      <div className="filter-group">
        <label htmlFor="analise-data-inicio">Período</label>
        <div className="periodo">
          <input
            id="analise-data-inicio"
            type="date"
            value={filtros.dataInicio}
            max={filtros.dataFim}
            onChange={alterar("dataInicio")}
          />
          <span>até</span>
          <input
            type="date"
            aria-label="Data final"
            value={filtros.dataFim}
            min={filtros.dataInicio}
            onChange={alterar("dataFim")}
          />
        </div>
      </div>

      <div className="filter-group">
        <label htmlFor="analise-perfil">Perfil</label>
        <select id="analise-perfil" value={filtros.perfil} onChange={alterar("perfil")}>
          <option value="">Todos os perfis</option>
          {PERFIS.map((perfil) => (
            <option key={perfil} value={perfil}>
              {perfil}
            </option>
          ))}
        </select>
      </div>

      <div className="filter-group">
        <label htmlFor="analise-acao">Tipo de ação</label>
        <select id="analise-acao" value={filtros.acao} onChange={alterar("acao")}>
          <option value="">Todos</option>
          <option value="Visualizacoes">Visualizações</option>
          <option value="Downloads">Downloads</option>
        </select>
      </div>

      <div className="filter-group">
        <label htmlFor="analise-pasta">Pasta</label>
        <select id="analise-pasta" value={filtros.idPasta} onChange={alterar("idPasta")}>
          <option value="">Todas as pastas</option>
          {pastas.map((pasta) => (
            <option key={pasta.id} value={pasta.id}>
              {pasta.caminho}
            </option>
          ))}
        </select>
      </div>

      <div className="filter-actions">
        {children}
        <button
          type="button"
          className="btn btn-primary"
          onClick={onAtualizar}
          disabled={carregando}
        >
          <FaArrowRotateRight /> {carregando ? "Atualizando..." : "Atualizar"}
        </button>
      </div>
    </section>
  );
}
